import { useTranslation } from 'react-i18next';
import ConfirmationModal from '../ConfirmationModal';

const BASE = 'SHARED_COMPONENTS.UNCONFIRMED_CHANGES_MODAL';

type Props = {
  id: string;
  onConfirm: () => void;
};

export default function UnconfirmedChangesDialog({ id, onConfirm }: Props) {
  const { t } = useTranslation();

  return (
    <ConfirmationModal
      id={id}
      headerTitle={t(`${BASE}.HEADER.TITLE`)}
      message={t(`${BASE}.BODY.TEXT`)}
      cancelLabel={t(`${BASE}.FOOTER.ACTIONS.CANCEL`)}
      confirmationText={t(`${BASE}.FOOTER.ACTIONS.CONFIRM`)}
      onConfirm={async () => onConfirm()}
    />
  );
}
